"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useResettableNetworkStatus_1 = require("./useResettableNetworkStatus");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return useResettableNetworkStatus_1.default; } });
//# sourceMappingURL=index.js.map